import React from 'react';
import { useTranslate } from '@hooks';
import { InputClipboard } from '@dotone/react-ui-core';
import { buildUrl } from './data';

const DocsRequestClipboard = ({ offerId, path, ...otherProps }) => {
  const { t } = useTranslate('docs');

  return (
    <div {...otherProps}>
      <h6 className="text-dark-light">{t('requestUrl')}</h6>
      <InputClipboard
        prepend="JSON"
        value={buildUrl(`advertisers/${path}.json${offerId ? `?offer_id=${offerId}` : ''}`)}
        className="mb-3"
      />
      <InputClipboard
        prepend="XML"
        value={buildUrl(`advertisers/${path}.xml${offerId ? `?offer_id=${offerId}` : ''}`)}
        className="mb-3"
      />
    </div>
  );
};

export default DocsRequestClipboard;
